(function () {
	'use strict';

	if (!window.HTMLElement || window.__zwBorlabsFocusFixInstalled) {
		return;
	}

	window.__zwBorlabsFocusFixInstalled = true;

	var originalFocus = window.HTMLElement.prototype.focus;

	function isBorlabsCloseButton(element) {
		return Boolean(
			element &&
			element.classList &&
			element.classList.contains('brlbs-cmpnt-close-button')
		);
	}

	function isOffscreenStaticElement(element) {
		if (
			!isBorlabsCloseButton(element) ||
			typeof element.getBoundingClientRect !== 'function' ||
			typeof window.getComputedStyle !== 'function'
		) {
			return false;
		}

		var styles = window.getComputedStyle(element);

		if (!styles || styles.position !== 'static') {
			return false;
		}

		var rect = element.getBoundingClientRect();
		var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

		return rect.top >= viewportHeight || rect.bottom <= 0;
	}

	function withPreventScroll(options) {
		var focusOptions = {};

		if (options && typeof options === 'object') {
			Object.keys(options).forEach(function (key) {
				focusOptions[key] = options[key];
			});
		}

		focusOptions.preventScroll = true;

		return focusOptions;
	}

	window.HTMLElement.prototype.focus = function zwBorlabsFocusFix(options) {
		if (isOffscreenStaticElement(this)) {
			return originalFocus.call(this, withPreventScroll(options));
		}

		return originalFocus.apply(this, arguments);
	};
}());
